import { render, staticRenderFns } from "./PublicationRecord.vue?vue&type=template&id=92c6c1de"
import script from "./PublicationRecord.vue?vue&type=script&lang=ts"
export * from "./PublicationRecord.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports